import React from "react";
import { Link } from "react-router-dom";

const ShortcutsItem = ({ text, filename, filename_dark, link, last, last2 }) => {
  // Utility function to handle conditional classes
  const classNames = (...classes) => classes.filter(Boolean).join(" ");

  // Base and dynamic classes
  const baseClasses =
    "bg-black w-1/2 xs:w-1/3 md:w-1/4 h-[200px] sm:max-w-[230px] max-w-[200px] xxxs:h-[220px] xxs:h-[250px] xs:h-[260px] sm:h-[280px] lg:h-[300px] bg-light-1 font-lg font-bold m-2 xxs:m-4 sm:m-4 lg:m-8 mt-2 mb-6 shadow-md z-10 relative overflow-hidden rounded-md transition-all duration-300 ease-in-out transform hover:scale-110";
  const dynamicClasses = classNames(last && "hidden md:block", last2 && "hidden xs:block");

  return (
    <div className={`${baseClasses} ${dynamicClasses}`}>
      {/* Link wrapper with hover effect */}
      <Link to={link} className="block bg-black h-full group">
        {/* Dark mode image */}
        <img
          src={`/assets/panels/${filename_dark}`}
          alt={text}
          className="h-full w-full object-cover dark:block hidden transition-transform duration-500 ease-out transform group-hover:translate-y-[-2%]"
        />
        {/* Light mode image */}
        <img
          src={`/assets/panels/${filename}`}
          alt={text}
          className="h-full w-full object-cover dark:hidden block transition-transform duration-500 ease-out transform group-hover:translate-y-[-2%]"
        />
        {/* Text with background gradient */}
        <p className="absolute bottom-0 left-0 right-0 px-2 xs:px-3 py-2 bg-gradient-to-b from-transparent to-black text-white text-2xl xxs:text-3xl font-semibold leading-tight drop-shadow">
          {text}
        </p>
      </Link>
    </div>
  );
};

export default ShortcutsItem;
